<div
  [class.theme-katya]="theme === 'cat'"
  [class.theme-dark]="theme === 'dark'"
  [class.dark-theme]="theme === 'dark'"
  [class.light-theme]="theme !== 'dark'"
  class="d-flex justify-content-between">
  <app-sidebar *ngIf="isAuth"></app-sidebar>
  <div class="w-100">
    <router-outlet></router-outlet>
  </div>
</div>
<div *ngIf="showCat" [@fade] class="cat_bg"></div>
<div *ngIf="showCat" [@fade] class="light"></div>
